import {DetailTable} from '../../../mapping-classes/detail-table';

export class Mobile implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(mobileCards: any) {
    if (!mobileCards || mobileCards.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = mobileCards.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(mobileCards);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen deelnemende rekeningen.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'cardNumber',
      'sequenceNumber',
      'status',
      'validUntil',
      'creationDate',
      'notificationPassFactoryDate',
      'expirationDate',
      'replacementDate',
      'replacementCardSequenceNumber',
      'startDate',
      'reason',
      'removable',
      'requestReason',
      'secureElementType',
      'secureElementId',
    ];
  }

  setRowData(mobileCards) {
    mobileCards.forEach((mobileCard) => {
      if (this.restrictedData) {
        mobileCard.compensationLimit = this.shieldedText;
        mobileCard.actualBalance = this.shieldedText;
      }
      this.rowData.push(mobileCard);
    });
  }
}
